/**
 * Updates the installment price text based on wallpaper total price calculation
 * Listens to width/height changes and variant updates
 */

function updateInstallmentPrice() {
  const installmentElements = document.querySelectorAll('[data-installment-price="true"]');
  
  if (installmentElements.length === 0) return;
  
  // Try to get the wallpaper-total-price directly (most reliable)
  const wallpaperTotalPriceElement = document.querySelector('.wallpaper-total-price');
  let totalPrice = 0;
  
  if (wallpaperTotalPriceElement) {
    const priceText = wallpaperTotalPriceElement.textContent || wallpaperTotalPriceElement.innerText || '';
    // Extract price from text like "€528,00" or "528,00"
    const priceMatch = priceText.match(/[\d.,]+/);
    if (priceMatch) {
      // Convert Dutch format (528,00) to number
      const priceString = priceMatch[0].replace(/\./g, '').replace(',', '.');
      totalPrice = parseFloat(priceString) || 0;
    }
  }
  
  // Fallback: calculate from width, height, and price if wallpaper-total-price not found
  if (totalPrice === 0) {
    let width = 300;
    let height = 250;
    
    // Get from Alpine.js data
    if (window.Alpine) {
      const wallpaperForm = document.querySelector('.wallpaper-form-wrapper [x-data]');
      if (wallpaperForm) {
        try {
          const alpineData = Alpine.$data(wallpaperForm);
          if (alpineData && alpineData.width) width = parseInt(alpineData.width) || width;
          if (alpineData && alpineData.height) height = parseInt(alpineData.height) || height;
        } catch (e) {
          // Alpine data not available
        }
      }
    }
    
    // Fallback to localStorage
    if (width === 300) {
      width = parseInt(localStorage.getItem('configurator_width')) || 300;
    }
    if (height === 250) {
      height = parseInt(localStorage.getItem('configurator_height')) || 250;
    }
    
    // Get current variant price
    let currentPrice = 0;
    const variantScript = document.querySelector('.variant-picker__form script');
    if (variantScript) {
      try {
        const variant = JSON.parse(variantScript.innerText);
        currentPrice = variant.price || 0;
      } catch (e) {
        // Variant script not available
      }
    }
    
    // Also try to get from Alpine.js if available
    if (window.Alpine && currentPrice === 0) {
      const wallpaperForm = document.querySelector('.wallpaper-form-wrapper [x-data]');
      if (wallpaperForm) {
        try {
          const alpineData = Alpine.$data(wallpaperForm);
          if (alpineData && alpineData.currentPrice) {
            currentPrice = alpineData.currentPrice;
          }
        } catch (e) {
          // Alpine data not available
        }
      }
    }
    
    if (currentPrice === 0) return;
    
    // Calculate wallpaper total price: ((width + 5) * (height + 5)) / 1000000 * currentPrice
    totalPrice = ((width + 5) * (height + 5)) / 1000000 * currentPrice;
  }
  
  // Only update if we have a valid price
  if (totalPrice === 0) return;
  
  // Calculate installment price (divide by 3)
  const installmentPrice = totalPrice / 3;
  
  // Format price in Dutch format
  const formattedPrice = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR'
  }).format(installmentPrice);
  
  // Update all installment price elements
  installmentElements.forEach(element => {
    const textContent = element.textContent || element.innerText || '';
    if (textContent.includes('Betaal in 3 delen van')) {
      // Replace the price part (everything after "van")
      const newText = textContent.replace(/Betaal in 3 delen van\s*[€€]?[\d.,]+/i, `Betaal in 3 delen van ${formattedPrice}`);
      if (element.textContent !== undefined) {
        element.textContent = newText;
      } else {
        element.innerText = newText;
      }
    }
  });
}

// Track last known values to detect changes
let lastWidth = null;
let lastHeight = null;
let lastTotalPrice = null;

function checkForChanges() {
  // Get current width and height from inputs
  const widthInput = document.querySelector('input[type="number"][x-model*="width"]');
  const heightInput = document.querySelector('input[type="number"][x-model*="height"]');
  
  let currentWidth = null;
  let currentHeight = null;
  
  if (widthInput) {
    currentWidth = parseInt(widthInput.value) || null;
  }
  
  if (heightInput) {
    currentHeight = parseInt(heightInput.value) || null;
  }
  
  // Also check wallpaper-total-price
  const wallpaperTotalPriceElement = document.querySelector('.wallpaper-total-price');
  let currentTotalPrice = null;
  
  if (wallpaperTotalPriceElement) {
    const priceText = wallpaperTotalPriceElement.textContent || wallpaperTotalPriceElement.innerText || '';
    const priceMatch = priceText.match(/[\d.,]+/);
    if (priceMatch) {
      const priceString = priceMatch[0].replace(/\./g, '').replace(',', '.');
      currentTotalPrice = parseFloat(priceString) || null;
    }
  }
  
  // Check if anything changed
  if (currentWidth !== lastWidth || currentHeight !== lastHeight || currentTotalPrice !== lastTotalPrice) {
    lastWidth = currentWidth;
    lastHeight = currentHeight;
    lastTotalPrice = currentTotalPrice;
    updateInstallmentPrice();
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  updateInstallmentPrice();
  
  // Set up interval to check for changes (as fallback)
  setInterval(checkForChanges, 300);
  
  // Listen to variant updates
  document.addEventListener('variant:update', () => {
    setTimeout(updateInstallmentPrice, 100); // Small delay to ensure variant data is updated
  });
  
  // Listen to localStorage changes (for width/height)
  window.addEventListener('storage', (e) => {
    if (e.key === 'configurator_width' || e.key === 'configurator_height') {
      updateInstallmentPrice();
    }
  });
  
  // Watch for changes to width/height input fields
  const setupInputObservers = () => {
    const widthInputs = document.querySelectorAll('input[type="number"][x-model*="width"]');
    const heightInputs = document.querySelectorAll('input[type="number"][x-model*="height"]');
    
    // Listen to input events
    [...widthInputs, ...heightInputs].forEach(input => {
      input.addEventListener('input', () => {
        // Wait a bit for Alpine to update the wallpaper-total-price
        setTimeout(updateInstallmentPrice, 150);
      });
      
      input.addEventListener('change', () => {
        setTimeout(updateInstallmentPrice, 150);
      });
    });
    
    // Also use MutationObserver to watch for value changes
    [...widthInputs, ...heightInputs].forEach(input => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            setTimeout(updateInstallmentPrice, 150);
          }
        });
      });
      
      observer.observe(input, {
        attributes: true,
        attributeFilter: ['value']
      });
    });
  };
  
  // Setup observers immediately
  setupInputObservers();
  
  // Also setup when Alpine is ready (in case inputs are added dynamically)
  if (window.Alpine) {
    document.addEventListener('alpine:init', () => {
      setTimeout(setupInputObservers, 100);
    });
  }
  
  // Watch for changes to the wallpaper-total-price element as backup
  const wallpaperTotalPriceElement = document.querySelector('.wallpaper-total-price');
  if (wallpaperTotalPriceElement) {
    const priceObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData' || mutation.type === 'childList') {
          // The price text changed, update installment price
          setTimeout(updateInstallmentPrice, 50);
        }
      });
    });
    
    priceObserver.observe(wallpaperTotalPriceElement, {
      characterData: true,
      childList: true,
      subtree: true
    });
  }
  
  // Listen to Alpine.js updates on the form wrapper
  if (window.Alpine) {
    document.addEventListener('alpine:init', () => {
      const wallpaperForm = document.querySelector('.wallpaper-form-wrapper [x-data]');
      if (wallpaperForm) {
        const observer = new MutationObserver(() => {
          setTimeout(updateInstallmentPrice, 100);
        });
        
        observer.observe(wallpaperForm, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true
        });
      }
    });
  }
  
  // Also listen to custom storage events (for cross-tab updates)
  const originalSetItem = Storage.prototype.setItem;
  Storage.prototype.setItem = function(key, value) {
    originalSetItem.apply(this, arguments);
    if (key === 'configurator_width' || key === 'configurator_height') {
      updateInstallmentPrice();
    }
  };
});

// Also run when Alpine is ready
if (window.Alpine) {
  document.addEventListener('alpine:init', () => {
    updateInstallmentPrice();
  });
}

